module.exports={
	"Scope": "RoleEdge-List",
	"CoreEntity": "RoleEdge",
	"TitleTemplate": "Role Edges",
	"Descriptors":
	{
		"ParentIDRole":
		{
			"Name": "Parent Role ID",
			"Hash": "RoleEdgeListParent",
			"PictDashboard": {}
		},
		"ChildIDRole":
		{
			"Name": "Child Role ID",
			"Hash": "RoleEdgeListChild",
			"PictDashboard": {}
		}
	}
}
